import type { MarketIdentifiers } from '$lib/types/market';
import { Interface } from 'ethers/lib/utils.js';
import abi from '$lib/web3/abi';
import { MARKET_ADDRESES } from '$lib/web3/addresses';
import { toBN } from '$lib/util/util';
import type { IConnectorReturnData } from '../types';

export const closeFullLimitTradeSmartContract = async (
	marketIdentifier: MarketIdentifiers,
	priceImpact: string,
	isUpper: boolean,
	triggerPrice: string,
	limitPrice: string,
	expiry: string
): Promise<IConnectorReturnData> => {
	const synthetixPerpConnector = 'Synthetix-Perp-Limit-Order-v1.1';
	const synthethixLimitOrderInterface = new Interface(abi.scWalletSynthetixPerpV2LimitOrder);
	const request = {
		isUpper: isUpper,
		triggerPrice: toBN(triggerPrice),
		limitPrice: toBN(limitPrice),
		sizeDelta: '0',
		priceImpactDelta: priceImpact,
		expiry: expiry
	};
	const tradeEncodedData = synthethixLimitOrderInterface.encodeFunctionData(
		'submitCloseLimitOrder',
		[MARKET_ADDRESES[marketIdentifier], request]
	);
	return {
		_target: synthetixPerpConnector,
		_callData: tradeEncodedData
	};
};
